import { useEffect } from 'react';

import './TableTitleExtraClass.css';

const addClassTableHeaderCell = (findClass: string, addClass: string) => {
    document.querySelector(`.${findClass}`)?.closest('.TableCell_isHeader')?.classList.add(addClass);
};

interface ITableTitleExtraClassProps {
    children: React.ReactNode;
    className: string;
    classNameExtra: string;
}

export const TableTitleExtraClass = ({ children, className, classNameExtra }: ITableTitleExtraClassProps) => {
    useEffect(() => {
        setTimeout(() => addClassTableHeaderCell(className, classNameExtra), 100);
    }, [className, classNameExtra]);

    return <div className={className}>{children}</div>;
};

TableTitleExtraClass.displayName = 'TableTitleExtraClass';
